import { render, staticRenderFns } from "./ICN001-05_battery_60.vue?vue&type=template&id=6f48eb42&"
import script from "./ICN001-05_battery_60.vue?vue&type=script&lang=js&"
export * from "./ICN001-05_battery_60.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports